import { ChronicDiseaseSimple } from '@dreryk/egabinet-patient-medical-information-frontend-api';

import { StrongText, StyledFlex } from '@dreryk/react-components';
import { Translate } from '@dreryk/react-common';

import { visitHistoryTranslationKeys } from '../../../translations';
import { DiagnosesFormTab } from '../../form/tabs/diagnoses/DiagnosesFormTab';
import { DiagnosesController } from '../../form/tabs/diagnoses/DiagnosesFormTab.types';
import { StyledPrescriptionVisitDataModalField } from '../PrescriptionVisitDataModal.styled';

type DiagnosesFieldProps = Pick<DiagnosesController, 'register'> & {
   readonly visitId: number;
   readonly dictionaryValidOn: Date;
   readonly chronicDiseases: ChronicDiseaseSimple[];
};

export const DiagnosesField = (props: DiagnosesFieldProps): JSX.Element => {
   return (
      <StyledPrescriptionVisitDataModalField>
         <StyledFlex direction={'column'} gap={4}>
            <StrongText testId={'diagnosesLabel'}>
               <Translate>{visitHistoryTranslationKeys.interviewTabs.diagnosis}</Translate>
            </StrongText>
            <DiagnosesFormTab
               register={props.register}
               visitId={props.visitId}
               dictionaryValidOn={props.dictionaryValidOn}
               chronicDiseases={props.chronicDiseases}
            />
         </StyledFlex>
      </StyledPrescriptionVisitDataModalField>
   );
};
